import styled from 'styled-components';

import { ACQ } from '../../theme/tokens';
import { hoverWash } from '../../theme/mixins';
import { Text } from '../Text/Text';

export const Card = styled.div<{ $clickable: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  border-radius: 16px;
  border: 1px solid transparent;
  background: ${ACQ.campCard};
  overflow: clip;
  cursor: ${(p) => (p.$clickable ? 'pointer' : 'default')};
  ${(p) => p.$clickable && hoverWash}
`;

// Eyebrow on its own row, then an avatar + title + drill-in chevron row (Figma).
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Avatar = styled.img`
  flex: 0 0 auto;
  width: 60px;
  height: 60px;
  border-radius: 16px;
  object-fit: cover;
`;

export const Title = styled(Text)`
  flex: 1 1 0;
  min-width: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.15;
  color: ${ACQ.t300};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
